// TODO(SGPD-547): confirm copy with the designer — the referenced Figma
// section (35641:15508) has no error frame; transition copy matches the
// design-approved ScratchPayPollingScreen wording (frame 35703:52739).
export const CHECKOUT_COPY = {
  TRANSITION_TITLE:
    "You’re heading to Scratch, GoodVets monthly subscription partner.",
  TRANSITION_SUBTITLE:
    "Watch for your one-time passcode to continue securely.",
  ERROR_TITLE: "We couldn’t open your checkout",
  ERROR_SUBTITLE: "This link may be invalid, expired, or already used.",
  ERROR_RETRY: "Try Again",
  ERROR_GO_HOME: "Go to Home",
} as const;
